import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/components/dashboard/dashboard-riderect.tsx");
